import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { err: null }; }
  static getDerivedStateFromError(err) { return { err }; }
  componentDidCatch(err, info) { console.error("Admin error:", err, info); }
  reset = () => this.setState({ err: null });
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center p-8" data-testid="admin-error-boundary">
          <div className="max-w-lg bg-white border border-[#9F1239]/40 p-8">
            <div className="mono text-[10px] uppercase tracking-widest text-[#9F1239]">Something went wrong</div>
            <div className="font-serif text-2xl text-navy mt-2">The admin page could not render.</div>
            <p className="text-sm text-stone2 mt-3">This has been logged. You can return to the dashboard or try again.</p>
            <pre className="mono text-[11px] text-stone2 bg-clinical p-3 mt-4 overflow-x-auto max-h-32">{String(this.state.err?.message || this.state.err)}</pre>
            <div className="mt-5 flex gap-2">
              <button onClick={this.reset} className="border border-navy text-navy text-sm px-4 py-2">Try again</button>
              <a href="/admin" className="bg-navy text-white text-sm px-4 py-2">Dashboard</a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
